<template>
  <div class="padded">
    <el-row align="middle">
      <h2><small>User Guide</small></h2>
    </el-row>

  <el-row type="flex" justify="start" align="top">

    <el-col :span="4" align="left">

      <el-menu
        v-model="menu"
        :unique-opened="true"
        @select="onClick">
<!--
background-color="#EBEEF5"
text-color="#909399"
active-text-color="#E6A23C"
-->
    <el-menu-item
            v-for="(item, index) in contents"
            v-if="item.visible && !item.children"
            :key="item.key"
            :index="'' + index">
              <template slot="title">
                <i :class="item.icon ? 'text-warning fa fa-' + item.icon : ''"></i>
                <b>{{isDesktop || isTablet ? item.title : ''}}</b>
              </template>

        </el-menu-item>
        <el-submenu
            v-for="(item, index) in contents"
            v-if="item.visible && item.children"
            :key="item.key"
            :index="'' + index">
              <template slot="title">
                <i :class="item.icon ? 'text-warning fa fa-' + item.icon : ''"></i>
                <b>{{item.title}}</b>
              </template>

              <el-menu-item
                  v-for="(sub, ind2) of item.children"
                  v-if="sub.visible"
                  :index="sub.key"
                  :disabled="sub.disabled"
                  :key="sub.key">

                <i :class="sub.icon ? 'text-muted fa fa-' + sub.icon : ''"></i>
                <span>{{sub.title}}</span>

              </el-menu-item>
        </el-submenu>


    </el-menu>

    </el-col>

    <el-col>
      <div class="padded">
        <pdf-viewer :url="url" :show-rotate="false" show-page-numbers-bottom />
      </div>
    </el-col>
  </el-row>


  </div>
</template>

<script>

import PdfViewer from '@/components/atoms/PdfViewer'

export default {

  components: {
    PdfViewer
  },

  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },

  methods: {
    onClick (item, path, data) {
      this.url = this.contents[item].url
    }
  },

  watch: {
    url: function (url) {
      this.url = url
    }
  },

  data () {
    return {
      menu: this.isTelco() ? '0-tel' : '0-intro',
      url: null,
      contents: [
        {key: '0-intro',
          title: 'Introduction',
          icon: 'info',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-intro-EN_P-ZfrYfcSm.pdf?updatedAt=1628693706495',
          visible: this.isTowerCo()
        },
        {key: '0-tel',
          title: 'Telco View',
          icon: 'phone',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-telco-EN_8RZvzQlIGqe.pdf?updatedAt=1628693707147',
          visible: this.isTelco() || this.canAccess('project|maintenance|finance|management')
        },
        {key: '0-main',
          title: 'Main Menu',
          icon: 'compass',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-menu-EN_hT6f-Fw_SE.pdf?updatedAt=1628693706066',
          visible: this.isTowerCo()
        },
        {key: '0-dash',
          title: 'Dashboards',
          icon: 'chart-pie',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-dashboards-EN_BY_eFV7Zps1S.pdf?updatedAt=1628693707141',
          visible: this.isTowerCo()
        },
        {key: '0-proj',
          title: 'Projects',
          icon: 'tools',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-projects-EN_BULJxqnzX.pdf?updatedAt=1631540297995',
          visible: this.isTowerCo() && this.canAccess('maintenance|project|management')
        },
        {key: '0-maint',
          title: 'Maintenance',
          icon: 'tools',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-maint-EN_aCVnn8wP-.pdf?updatedAt=1628693706815',
          visible: this.isTowerCo() && this.canAccess('maintenance|project|management')
        },
        {key: '0-prop',
          title: 'Tenancy',
          icon: 'home',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-tenancy-EN_yqQewX4Ta.pdf?updatedAt=1628693706434',
          visible: this.isTowerCo() && this.canAccess('property|finance|management')
        },
        {key: '0-fin',
          title: 'Finance',
          icon: 'money-bill-alt',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-finance-EN_3BiG0r1Dn.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1659667801013',
          visible: this.isTowerCo() && this.canAccess('finance|management')
        },
        {key: '0-ops',
          title: 'Operations',
          icon: 'users-cog',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-admin-EN_nAkiDw07Y70.pdf?updatedAt=1628693706412',
          visible: this.isTowerCo() && this.canAccess('project|maintenance|property|finance|admin|management')
        },
        {key: '0-appendix-a',
          title: 'Appendix A',
          icon: 'cogs',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-appendix-A-EN_Fg5LGI3YW.pdf?updatedAt=1628693705530',
          visible: this.isTowerCo() && this.canAccess('project|maintenance|finance|management')
        },
        {key: '0-appendix-b',
          title: 'Appendix B',
          icon: 'map-pin',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/EN/xolas-tms-appendix-B-EN_FUlHe2fj-Z.pdf?updatedAt=1628693705819',
          visible: this.isTowerCo() && this.canAccess('project|finance|property|admin|management')
        }
      ]
    }
  },

  created () {
    this.url = this.isTelco() ? this.contents[1].url : this.contents[0].url
  }
}
</script>
